var _path, _circle, _path2, _circle2, _path3, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPersons(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 117,
    height: 70,
    viewBox: "0 0 117 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M115.398 49.211V39.7608C111.618 32.2011 104.059 28.4211 92.7186 28.4211C86.5658 28.4211 81.5259 29.5339 77.5987 31.7594",
    stroke: "#1B1E59",
    strokeWidth: 2.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 92.7188,
    cy: 11.3399,
    r: 10.2149,
    stroke: "#1B1E59",
    strokeWidth: 2.25
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M81.3792 70.0002V58.6603C77.5993 51.1005 70.0393 47.3206 58.6994 47.3206C47.3595 47.3206 39.7995 51.1005 36.0195 58.6603V70.0002",
    stroke: "#1B1E59",
    strokeWidth: 2.25
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 58.6993,
    cy: 30.3106,
    r: 10.2149,
    fill: "#05F29B",
    stroke: "#1B1E59",
    strokeWidth: 2.25
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2 49.211V39.7608C5.77998 32.2011 13.3399 28.4211 24.6799 28.4211C30.8326 28.4211 35.8726 29.5339 39.7998 31.7594",
    stroke: "#1B1E59",
    strokeWidth: 2.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 24.6798,
    cy: 11.3399,
    r: 10.2149,
    stroke: "#1B1E59",
    strokeWidth: 2.25
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPersons);
export default __webpack_public_path__ + "static/media/Icon_Persons.d4ce6130aefa432a7ea61fb361317df1.svg";
export { ForwardRef as ReactComponent };